<script lang="ts" setup>
import { MOBILE_IMAGE_SIZE } from '~/constants/common/index'
import GoodsImage from '~/components/common/modules/units/goods-image.vue'
import { InfoGiftItem } from '~/api/types/goods'
import ModalDetailGift from './layer/modal-detail-gift.vue'

export interface Props {
  items?: InfoGiftItem
}

const props = withDefaults(defineProps<Props>(), {})

const isShowGift = ref<boolean>(false)
const unitCd = ref<number>(0)
const isAdult = computed<boolean>(() => props.items?.adltGoodsYn === 'Y')
const giftBnftList = ref()
const isMounted = ref<boolean>(false)

function _onClickShowAll(value: number) {
  isShowGift.value = true
  unitCd.value = value
}

function onError(item: any) {
  item.isGoodsImg = false
}

onMounted(() => {
  giftBnftList.value = props.items?.giftBnftList?.map((item: any) => {
    return {
      ...item,
      isGoodsImg: true
    }
  })
})
</script>
<template>
  <template v-for="(item, index) in giftBnftList" :key="index">
    <div class="info-gift-wrap" v-if="item.displayYn === 'Y'">
      <dl>
        <dt>구성품</dt>
        <dd class="gift-list">
          <div class="row">
            <figure>
              <GoodsImage
                v-if="item.isGoodsImg"
                :goods-cd="item?.goodsCd"
                :config="{
                  width: MOBILE_IMAGE_SIZE.DETAIL_UNIT.FREEBIES.WIDTH,
                  height: MOBILE_IMAGE_SIZE.DETAIL_UNIT.FREEBIES.HEIGHT,
                  alt: item?.giftTitle,
                  isAdult: isAdult
                }"
                @on-error="onError(item)"
              />
            </figure>
            <div class="gift-info">
              <p class="text">{{ item.unitList[0].unitNm }}</p>
            </div>
          </div>
        </dd>
      </dl>

      <div class="gift-button-wrap" v-if="item?.unitList && item?.unitList.length > 1">
        <button type="button" class="gift-btn" @click="_onClickShowAll(item?.goodsCd)">
          <i>구성품 전체보기 <span>(택1)</span></i>
        </button>
      </div>
    </div>
  </template>

  <ModalDetailGift v-model="isShowGift" :unitCd="unitCd" :items="items?.giftBnftList!" />
</template>
<style lang="scss">
@use '~/pages/goods/scss/info-gift.scss';
</style>
